import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = ['item', 'option', 'dateFieldInput', 'dateField', 'durationFieldInput', 'durationField']

  toggle() {
    const selectedOption = this.optionTargets.find(radio => radio.checked).value

    if (selectedOption === 'true') {
      this.itemTarget.classList.remove('d-none')
    } else {
      this.itemTarget.classList.add('d-none')
    }
  }

  updateDisplay() {
    const copiedDateValue = this.dateFieldInputTarget.value;
    const copiedDurationValue = this.durationFieldInputTarget.value
    const formattedDate = this._formatDate(copiedDateValue);
    const formattedTimespan = this._formatTimespan(copiedDateValue, copiedDurationValue);
    this.dateFieldTarget.textContent = `The scheduled activity will be moved to ${formattedDate} and all activities will be rescheduled to ${formattedTimespan}`;
  }

  _formatDate(datetimeString) {
    const date = new Date(datetimeString);

    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }

    const optionsDate = { weekday: 'short', month: 'numeric', day: 'numeric' };

    const formattedDate = date.toLocaleDateString('en-US', optionsDate);

    return formattedDate;
  }

  _formatTimespan(startingDateTimeString, durationInMinutesString) {
    const startTime = new Date(startingDateTimeString);

    if (isNaN(startTime.getTime())) {
      return 'Invalid Start Time';
    }

    const durationMilliseconds = parseInt(durationInMinutesString) * 60000; // 1 minute = 60000 milliseconds
    const endTime = new Date(startTime.getTime() + durationMilliseconds);

    const options = { hour: 'numeric', minute: '2-digit', hour12: true };

    const formattedStartTime = startTime.toLocaleTimeString('en-US', options);
    const formattedEndTime = endTime.toLocaleTimeString('en-US', options);

    return `${formattedStartTime} to ${formattedEndTime}`;
  }
}
